<template>
    <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab :title="bloque.detalle"  v-for="bloque in array_bloques" v-if="bloque.presentacion=='Si'">
                <b-card-group deck>
                      <b-card v-for="usuario in array_usuarios" v-if="usuario.id_bloque==bloque.id"
                      aling="center"
                            :img-src="usuario.imagen64" 
                            img-alt="Card image" 
                            :title="usuario.tx_nombre+' '+usuario.tx_apellidoPaterno"
                            style="max-width: 20rem; min-width: 20rem;"
                            img-top>
                            <b-card-text>
                                  <p>{{usuario.tx_descripcion }}</p>
                            </b-card-text>
                            <template #footer>
                                <small class="text-muted">Periodo desde el: 10/12/{{usuario.inicio_periodo}} hasta el 10/12/{{usuario.final_periodo}}</small>
                            </template>        
                      </b-card>
                </b-card-group>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
</template>

<style>

</style>

<script>
  import { mapState, mapActions } from 'vuex';
  import { mapMutations } from 'vuex'
  export default {
    name: 'Home', 
    components: {
    },
    computed:{
        ...mapState(['host','array_bloques','array_usuarios']),
    },  
    methods:{
      ...mapActions(['CargarBloques','CargarUsuarios']), 
    },

    data() {
      return {
          id:0,
          opciones:{presentacion:'Si', eliminado:'No', seleccion:'No'}, 
      }
    },   
    created(){
        this.CargarUsuarios();
        this.CargarBloques(this.opciones);   
    },
  }
</script>
